<template>
  <div>
    <!-- <section class="catg-area">
      <div class="container">
        <CategoryList />
      </div>
    </section> -->
    <section class="client-listing-area">
      <div class="client-listing-head-fluid" style="padding-bottom: 5px;">
        <div class="container">
          <div class="client-listing-head">
            <SearchBar />
          </div>
          <!-- ends client-listing-head -->
        </div>
      </div>
      <!-- ends client-listing-head-fluid -->
      <div class="client-listing-detail-fluid">
        <div class="container px-0">
          <div class="client-listing-detail">
            <ApplicantList v-if="defaultSearchLoaded" />
          </div>
          <!-- ends client-listing-detail -->
        </div>
      </div>
      <!-- ends client-listing-detail-fluid -->
    </section>
  </div>
</template>

<script>
import ApplicantList from '@/components/dashboard/applicants/ApplicantList.vue';
import SearchBar from '@/components/dashboard/applicants/SearchBar.vue';
// import CategoryList from '@/components/dashboard/category/CategoryList.vue';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
  name: 'Applicants',
  components: { SearchBar, ApplicantList },
  
  data() {
    return {
      defaultSearchLoaded: false,
    };
  },

  async mounted() {
    await this.loadCurrentUserDefaultSearch();
    this.defaultSearchLoaded = true;
    this.changeBodyBackground();
  },

  methods: {
    ...mapMutations({
      setStatusModel: 'setStatusModel',
      setProfileModalState: 'setProfileModalState',
      resetApplicantListState: 'resetApplicantListState',
    }),
    ...mapActions([
      'loadCurrentUserDefaultSearch',
    ]),
  },

  computed: {
    ...mapGetters({
      isReviewer: 'isCreateReviewUser',
      user: 'getCurrentUser',
      defaultLoaded: 'getDefaultLoaded',
    }),
  },

  beforeRouteLeave(to, from, next) {
    this.resetApplicantListState();
    this.setProfileModalState(false);
    this.setStatusModel([]);
    this.defaultSearchLoaded = false;
    next();
  },
};
</script>